// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable max-len */

export const menuData = [
  {
    id: 'filtroInformacion',
    name: 'FILTRE INFORMACIÓN SEGÚN DIFERENTES DIMENSIONES',
    type: 'main',
    icon: 'BookmarksOutlined',
    arrowIcon: 'ExpandMore',
    submenu: [
      {
        id: 'pilaresProgPDI',
        name: 'PILARES Y PROGRAMAS DEL PDI',
        render: null,
        icon: 'un.png',
        arrowIcon: 'DetailsOutlined',
        type: 'firstChildren',
        submenu: [
          {
            id: 'pilares',
            name: 'Todos los pilares',
            color: '#f15b4e',
            render: 'Option',
            style: {
              prop: 'circle-radius',
              value: ['interpolate', ['linear'], ['zoom'], 5, 3, 8, 5]
            },
            icon: 'todos_pilares.png',
            type: 'secondChildren',
            queryRedmine: [...new Array(100).keys()].map((v) => v.toString()),
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326',
            submenu: []
          },
          {
            id: 'pDesEco',
            name: 'Pilar Desarrollo Económico',
            render: 'Option',
            color: '#379d8d',
            icon: 'pilar_1.png',
            type: 'secondChildren',
            arrowIcon: 'DetailsOutlined',
            queryRedmine: ['22', '23', '24', '25', '26'],
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(pilar_desarrollo_economico=%27t%27)',
            submenu: [
              {
                id: 'infraestructura',
                name: 'Infraestructura habilitante',
                render: 'Option',
                color: '#379d8d',
                icon: 'infra_habilitante.png',
                queryRedmine: '22',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(infra_habilitante=%27t%27)',
                submenu: []
              },
              {
                id: 'fomento',
                name: 'Fomento comercial e integración regional',
                render: 'Option',
                color: '#379d8d',
                icon: 'fomento_regional.png',
                queryRedmine: '23',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(fomento_regional=%27t%27)',
                submenu: []
              },
              {
                id: 'desarrolloProd',
                name: 'Desarrollo productivo',
                render: 'Option',
                color: '#379d8d',
                icon: 'desarrollo_productivo.png',
                queryRedmine: '24',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(desarrollo_productivo=%27t%27)',
                submenu: []
              },
              {
                id: 'desarrolloTerr',
                name: 'Desarrollo territorial',
                render: 'Option',
                color: '#379d8d',
                icon: 'desarrollo_territorial.png',
                queryRedmine: '25',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(desarrollo_territorial=%27t%27)',
                submenu: []
              },
              {
                id: 'macDesarrollo',
                name: 'Macroeconomía para el desarrollo',
                render: 'Option',
                color: '#379d8d',
                icon: 'macroeconomia.png',
                queryRedmine: '26',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(macroeconomia=%27t%27)',
                submenu: []
              }
            ]
          },
          {
            id: 'pBienestarSocial',
            name: 'Pilar Bienestar Social',
            render: 'Option',
            color: '#8fb9de',
            icon: 'pilar_2.png',
            queryRedmine: ['27', '28', '29', '30', '31'],
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(pilar_bienestar_social=%27t%27)',
            type: 'secondChildren',
            arrowIcon: 'DetailsOutlined',
            submenu: [
              {
                id: 'incSocialLaboral',
                name: 'Inclusión social y laboral',
                render: 'Option',
                color: '#8fb9de',
                icon: 'inclusion_social.png',
                queryRedmine: '27',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(inclusion_social=%27t%27)',
                submenu: []
              },
              {
                id: 'habVida',
                name: 'Habilidades para la vida',
                render: 'Option',
                color: '#8fb9de',
                icon: 'habilidades.png',
                queryRedmine: '28',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(habilidades=%27t%27)',
                submenu: []
              },
              {
                id: 'desarrolloInfantil',
                name: 'Desarrollo infantil integral',
                render: 'Option',
                color: '#8fb9de',
                icon: 'desarrollo_infantil.png',
                queryRedmine: '29',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(desarrollo_infantil=%27t%27)',
                submenu: []
              },
              {
                id: 'saludVida',
                name: 'Salud a lo largo de la vida',
                render: 'Option',
                color: '#8fb9de',
                icon: 'salud.png',
                queryRedmine: '30',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(salud=%27t%27)',
                submenu: []
              },
              {
                id: 'prevViolencia',
                name: 'Prevención de violencia y cultura de paz',
                render: 'Option',
                color: '#8fb9de',
                icon: 'prevencion_violencia.png',
                queryRedmine: '31',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(prevencion_violencia=%27t%27)',
                submenu: []
              }
            ]
          },
          {
            id: 'pCambioClimatico',
            name: 'Pilar de Respuesta al cambio climático',
            render: 'Option',
            color: '#f79440',
            icon: 'pilar_3.png',
            queryRedmine: ['32', '33', '34'],
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(pilar_cambio_climatico=%27t%27)',
            type: 'secondChildren',
            arrowIcon: 'DetailsOutlined',
            submenu: [
              {
                id: 'genConocimiento',
                name: 'Generación de conocimiento, datos y herramientas para la adaptación al cambio climático y riesgos de desastres',
                render: 'Option',
                color: '#f79440',
                icon: 'generacion_conocimiento.png',
                queryRedmine: '32',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(generacion_conocimiento=%27t%27)',
                submenu: []
              },
              {
                id: 'fortResiliencia',
                name: 'Fortalecimiento de la resiliencia para prevenir el desplazamiento por desastres',
                render: 'Option',
                color: '#f79440',
                icon: 'fortalecimiento_resiliencia.png',
                queryRedmine: '33',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(fortalecimiento_resiliencia=%27t%27)',
                submenu: []
              },
              {
                id: 'cambioClimatico',
                name: 'Cambio climático y soluciones basadas en la naturaleza',
                render: 'Option',
                color: '#f79440',
                icon: 'cambio_climatico.png',
                queryRedmine: '34',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(cambio_climatico=%27t%27)',
                submenu: []
              }
            ]
          },
          {
            id: 'pGEstionIntegral',
            name: 'Pilar Gestión integral del ciclo migratorio',
            render: 'Option',
            color: '#3dc3dd',
            icon: 'pilar_4.png',
            queryRedmine: ['35', '36'],
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(pilar_ciclo_migratorio=%27t%27)',
            type: 'secondChildren',
            arrowIcon: 'DetailsOutlined',
            submenu: [
              {
                id: 'respIntegrales',
                name: 'Respuestas integrales nacionales',
                render: 'Option',
                color: '#3dc3dd',
                icon: 'respuestas_integrales.png',
                queryRedmine: '35',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(respuestas_integrales=%27t%27)',
                submenu: []
              },
              {
                id: 'accionesRegionales',
                name: 'Acciones regionales',
                render: 'Option',
                color: '#3dc3dd',
                icon: 'acciones_regionales.png',
                queryRedmine: '36',
                query:
                  'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(acciones_regionales=%27t%27)',
                submenu: []
              }
            ]
          }
        ]
      },
      {
        id: 'nivTerritorial',
        name: 'NIVEL TERRITORIAL',
        render: null,
        icon: 'un.png',
        color: '#686868',
        arrowIcon: 'DetailsOutlined',
        type: 'firstChildren',
        submenu: [
          {
            id: 'Regional',
            name: 'Regional',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            color: '#686868',
            queryRedmine: 'Supranacional',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(alcance_supranacional=%27t%27)',
            submenu: []
          },
          {
            id: 'Nacional',
            name: 'Nacional',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            color: '#686868',
            queryRedmine: 'Nacional',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(alcance_nacional=%27t%27)',
            submenu: []
          },
          {
            id: 'Subnacional',
            name: 'Subnacional',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            color: '#686868',
            queryRedmine: 'Subnacional',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(alcance_subnacional=%27t%27)',
            submenu: []
          }
        ]
      },
      {
        id: 'ODS',
        name: 'ODS',
        render: null,
        icon: 'un.png',
        arrowIcon: 'DetailsOutlined',
        type: 'firstChildren',
        submenu: [
          {
            id: '1',
            color: '#ff152a',
            name: 'ODS 1',
            render: 'Option',
            icon: 'ods/ods_1.png',
            type: 'secondChildren',
            queryRedmine: 'ods_1',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_1=%27t%27)',
            submenu: []
          },
          {
            id: '2',
            color: '#e4a10b',
            name: 'ODS 2',
            render: 'Option',
            icon: 'ods/ods_2.png',
            type: 'secondChildren',
            queryRedmine: 'ods_2',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_2=%27t%27)',
            submenu: []
          },
          {
            id: '3',
            color: '#009c3f',
            name: 'ODS 3',
            render: 'Option',
            icon: 'ods/ods_3.png',
            type: 'secondChildren',
            queryRedmine: 'ods_3',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_3=%27t%27)',
            submenu: []
          },
          {
            id: '4',
            color: '#e4182d',
            name: 'ODS 4',
            render: 'Option',
            icon: 'ods/ods_4.png',
            type: 'secondChildren',
            queryRedmine: 'ods_4',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_4=%27t%27)',
            submenu: []
          },
          {
            id: '5',
            color: '#ff3e25',
            name: 'ODS 5',
            render: 'Option',
            icon: 'ods/ods_5.png',
            type: 'secondChildren',
            queryRedmine: 'ods_5',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_5=%27t%27)',
            submenu: []
          },
          {
            id: '6',
            color: '#00b0dc',
            name: 'ODS 6',
            render: 'Option',
            icon: 'ods/ods_6.png',
            type: 'secondChildren',
            queryRedmine: 'ods_6',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_6=%27t%27)',
            submenu: []
          },
          {
            id: '7',
            color: '#ffb80d',
            name: 'ODS 7',
            render: 'Option',
            icon: 'ods/ods_7.png',
            type: 'secondChildren',
            queryRedmine: 'ods_7',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_7=%27t%27)',
            submenu: []
          },
          {
            id: '8',
            color: '#a61136',
            name: 'ODS 8',
            render: 'Option',
            icon: 'ods/ods_8.png',
            type: 'secondChildren',
            queryRedmine: 'ods_8',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_8=%27t%27)',
            submenu: []
          },
          {
            id: '9',
            color: '#ff6d15',
            name: 'ODS 9',
            render: 'Option',
            icon: 'ods/ods_9.png',
            type: 'secondChildren',
            queryRedmine: 'ods_9',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_9=%27t%27)',
            submenu: []
          },
          {
            id: '10',
            color: '#ff0d88',
            name: 'ODS 10',
            render: 'Option',
            icon: 'ods/ods_10.png',
            type: 'secondChildren',
            queryRedmine: 'ods_10',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_10=%27t%27)',
            submenu: []
          },
          {
            id: '11',
            color: '#ff9f02',
            name: 'ODS 11',
            render: 'Option',
            icon: 'ods/ods_11.png',
            type: 'secondChildren',
            queryRedmine: 'ods_11',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_11=%27t%27)',
            submenu: []
          },
          {
            id: '12',
            color: '#e4901e',
            name: 'ODS 12',
            render: 'Option',
            icon: 'ods/ods_12.png',
            type: 'secondChildren',
            queryRedmine: 'ods_12',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_12=%27t%27)',
            submenu: []
          },
          {
            id: '13',
            color: '#1d7a38',
            name: 'ODS 13',
            render: 'Option',
            icon: 'ods/ods_13.png',
            type: 'secondChildren',
            queryRedmine: 'ods_13',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_13=%27t%27)',
            submenu: []
          },
          {
            id: '14',
            color: '#007ec0',
            name: 'ODS 14',
            render: 'Option',
            icon: 'ods/ods_14.png',
            type: 'secondChildren',
            queryRedmine: 'ods_14',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_14=%27t%27)',
            submenu: []
          },
          {
            id: '15',
            color: '#00b23e',
            name: 'ODS 15',
            render: 'Option',
            icon: 'ods/ods_15.png',
            type: 'secondChildren',
            queryRedmine: 'ods_15',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_15=%27t%27)',
            submenu: []
          },
          {
            id: '16',
            color: '#00548e',
            name: 'ODS 16',
            render: 'Option',
            icon: 'ods/ods_16.png',
            type: 'secondChildren',
            queryRedmine: 'ods_16',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_16=%27t%27)',
            submenu: []
          },
          {
            id: '17',
            color: '#00336a',
            name: 'ODS 17',
            render: 'Option',
            icon: 'ods/ods_17.png',
            type: 'secondChildren',
            queryRedmine: 'ods_17',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ods_17=%27t%27)',
            submenu: []
          }
        ]
      },
      {
        id: 'entImplementadora',
        name: 'ENTIDAD IMPLEMENTADORA',
        render: null,
        icon: 'un.png',
        arrowIcon: 'DetailsOutlined',
        type: 'firstChildren',
        submenu: [
          {
            id: 'acnur',
            name: 'ACNUR',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'ACNUR',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(acnur=%27t%27)',
            submenu: []
          },
          {
            id: 'banco_mundial',
            name: 'Banco Mundial',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'Banco Mundial',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(banco_mundial=%27t%27)',
            submenu: []
          },
          {
            id: 'fao',
            name: 'FAO',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'FAO',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(fao=%27t%27)',
            submenu: []
          },
          {
            id: 'fida',
            name: 'FIDA',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'FIDA',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(fida=%27t%27)',
            submenu: []
          },
          {
            id: 'itc',
            name: 'ITC',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'ITC',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(itc=%27t%27)',
            submenu: []
          },
          {
            id: 'oacnudh',
            name: 'OACNUDH',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'OACNUDH',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(oacnudh=%27t%27)',
            submenu: []
          },
          {
            id: 'ocha',
            name: 'OCHA',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'OCHA',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ocha=%27t%27)',
            submenu: []
          },
          {
            id: 'oim',
            name: 'OIM',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'OIM',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(oim=%27t%27)',
            submenu: []
          },
          {
            id: 'oit',
            name: 'OIT',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'OIT',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(oit=%27t%27)',
            submenu: []
          },
          {
            id: 'onu_habitat',
            name: 'ONU Habitat',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'ONU Habitat',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(onu_habitat=%27t%27)',
            submenu: []
          },
          {
            id: 'onu_mujeres',
            name: 'ONU Mujeres',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'ONU Mujeres',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(onu_mujeres=%27t%27)',
            submenu: []
          },
          {
            id: 'onudi',
            name: 'ONUDI',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'ONUDI',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(onudi=%27t%27)',
            submenu: []
          },
          {
            id: 'onusida',
            name: 'ONUSIDA',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'ONUSIDA',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(onusida=%27t%27)',
            submenu: []
          },
          {
            id: 'ops_oms',
            name: 'OPS/OMS',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'OPS/OMS',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(ops_oms=%27t%27)',
            submenu: []
          },
          {
            id: 'pma',
            name: 'PMA',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'PMA',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(pma=%27t%27)',
            submenu: []
          },
          {
            id: 'pnud',
            name: 'PNUD',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'PNUD',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(pnud=%27t%27)',
            submenu: []
          },
          {
            id: 'pnuma',
            name: 'PNUMA',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'PNUMA',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(pnuma=%27t%27)',
            submenu: []
          },
          {
            id: 'unesco',
            name: 'UNESCO',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'UNESCO',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(unesco=%27t%27)',
            submenu: []
          },
          {
            id: 'unfpa',
            name: 'UNFPA',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'UNFPA',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(unfpa=%27t%27)',
            submenu: []
          },
          {
            id: 'unicef',
            name: 'UNICEF',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'UNICEF',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(unicef=%27t%27)',
            submenu: []
          },
          {
            id: 'unodc',
            name: 'UNODC',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'UNODC',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(unodc=%27t%27)',
            submenu: []
          },
          {
            id: 'unops',
            name: 'UNOPS',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'UNOPS',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(unops=%27t%27)',
            submenu: []
          }
        ]
      },
      {
        id: 'cooperation',
        name: 'AGENCIAS DE COOPERACIÓN',
        render: null,
        icon: 'un.png',
        arrowIcon: 'DetailsOutlined',
        type: 'firstChildren',
        submenu: [
          {
            id: 'amexcid',
            name: 'AMEXCID',
            render: 'Option',
            icon: 'un.png',
            type: 'secondChildren',
            queryRedmine: 'AMEXCID',
            query:
              'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326&CQL_FILTER=(amexcid=%27t%27)',
            submenu: []
          }
        ]
      }
    ]
  },
  {
    id: 'MenuIndicator',
    name: 'AGREGUE CAPAS DE INFORMACIÓN ESTADÍSTICA',
    render: 'MenuIndicator',
    type: 'main',
    icon: 'BookmarksOutlined',
    arrowIcon: 'ExpandMore'
  },
  {
    id: 'MenuExternalLayers',
    name: 'AGREGUE CAPAS GEOGRÁFICAS',
    render: 'MenuExternalLayers',
    type: 'main',
    icon: 'BookmarksOutlined',
    arrowIcon: 'ExpandMore'
  }
]
